document.addEventListener("DOMContentLoaded", function () {
    const goalSelectors = document.querySelectorAll('.goal-selector')

    goalSelectors.forEach((goalSelector) => {
        const goalItems = goalSelector.querySelectorAll('.goal-selector__item button')

        if (goalItems.length) {
            goalItems.forEach((item) => {
                item.onclick = () => {
                    // Unselect all items
                    unselectAllItems(goalItems)

                    // Mark the "goal-selector__cards" div as active
                    goalSelector.querySelector('.goal-selector__cards').classList.add('goal-selector__cards--active')

                    // Check if is the "See all" button
                    if (item.closest('.goal-selector__item').classList.contains('goal-selector__item--all')) {
                        // Show all items
                        const cards = item.closest('.goal-selector').querySelectorAll('.goal-selector__card')
                        cards.forEach((card, index) => {
                            card.classList.add('goal-selector__card--active')
                            // Scroll to the first card
                            if (index == 0) {
                                cards[0].scrollIntoView({ behavior: 'smooth' })
                            }
                        })
                        item.setAttribute('aria-expanded', true)
                    } else {
                        // select the clicked item
                        selectItem(item)
                    }
                }
            })
        }
    })

    // Unselect all items
    function unselectAllItems(goalItems) {
        goalItems.forEach((item) => {
            item.setAttribute('aria-expanded', 'false')
            const cards = item.closest('.goal-selector').querySelectorAll('.goal-selector__card')
            cards.forEach((targetCard) => {
                targetCard.classList.remove('goal-selector__card--active')
                targetCard.setAttribute('tabindex', '-1')
            })
        })
    }
    
    // Select item
    function selectItem(item) {
        item.setAttribute('aria-expanded', 'true')
        const targetCard = document.getElementById(item.getAttribute('aria-controls'))
        targetCard.classList.add('goal-selector__card--active')
        targetCard.scrollIntoView({ behavior: 'smooth' })
        targetCard.setAttribute('tabindex', '0')
        targetCard.focus()
    }
})
